export const IGNORE_AUTO_SCORE_MESSAGES = {
  label: 'Ignore Auto Score',
  infoMessage: {
    ignore: 'Ignore auto scores for this well.',
    unignore: 'Unignore auto scores for this well.',
  },
  buttonText: {
    ignore: 'IGNORE',
    unignore: 'UNIGNORE',
  },
  confirmation: {
    cancelButton: 'NO, CANCEL',
    ignore: {
      heading: 'Ignore Wrong Autoscore',
      body: 'Are you sure you want to ignore the autoscore result for this drop?',
      okButton: 'YES, IGNORE',
    },
    unignore: {
      heading: 'Unignore Wrong Autoscore',
      body: 'Are you sure you want to unignore the autoscore result for this drop?',
      okButton: 'YES, UNIGNORE',
    },
  },
  success: {
    ignore: {
      heading: 'Ignore Wrong Autoscore',
      body: 'Auto score has been ignored.',
    },
    unignore: {
      heading: 'Unignore Wrong Autoscore',
      body: 'This item is no longer ignored and will be included in the hit count.',
    },
  },
  error: {
    ignoreFailed: 'Failed to ignore auto scores.',
    unignoreFailed: 'Failed to unignore auto scores.',
  },
  hitCountRecalculation:
    'Hit counts are being recalculated in the background. Explorer counts may update shortly.',
} as const;

export function getIgnoreAutoScoreSuccessModalMessages(shouldIgnore: boolean) {
  const messages = shouldIgnore
    ? IGNORE_AUTO_SCORE_MESSAGES.success.ignore
    : IGNORE_AUTO_SCORE_MESSAGES.success.unignore;

  return {
    heading: messages.heading,
    body: messages.body,
    showButtons: false as const,
    hideFooter: true as const,
  };
}

export function getIgnoreAutoScoreErrorMessage(shouldIgnore: boolean): string {
  return shouldIgnore
    ? IGNORE_AUTO_SCORE_MESSAGES.error.ignoreFailed
    : IGNORE_AUTO_SCORE_MESSAGES.error.unignoreFailed;
}

export function getIgnoreAutoScoreConfirmationMessages(shouldIgnore: boolean) {
  const messages = shouldIgnore
    ? IGNORE_AUTO_SCORE_MESSAGES.confirmation.ignore
    : IGNORE_AUTO_SCORE_MESSAGES.confirmation.unignore;

  return {
    heading: messages.heading,
    body: messages.body,
    noButtonText: IGNORE_AUTO_SCORE_MESSAGES.confirmation.cancelButton,
    okButtonText: messages.okButton,
  };
}

export function getIgnoreAutoScoreInfoMessage(isIgnored: boolean): string {
  return isIgnored
    ? IGNORE_AUTO_SCORE_MESSAGES.infoMessage.unignore
    : IGNORE_AUTO_SCORE_MESSAGES.infoMessage.ignore;
}

export function getIgnoreAutoScoreButtonText(isIgnored: boolean): string {
  return isIgnored
    ? IGNORE_AUTO_SCORE_MESSAGES.buttonText.unignore
    : IGNORE_AUTO_SCORE_MESSAGES.buttonText.ignore;
}
